import IndividualNamePreview from "../../../components/clients/IndividualNamePreview";
import { MOBILE_TEXT_ENTRY_PROPS } from "./mobileTextEntryProps";
import "./MobileIndividualNamePreview.css";

export default function MobileIndividualNamePreview({ displayName = "", disabled = false, value, onChange }) {
  return (
    <IndividualNamePreview
      inputClass="form-control kycMobileNamePreview"
      displayName={displayName}
      value={value}
      onChange={onChange}
      disabled={disabled}
      inputProps={MOBILE_TEXT_ENTRY_PROPS}
      framed
    />
  );
}
